import { visitPaths } from '~libs.desktop.shared.paths';

import {
   AppointmentConfirmationStatus,
   AppointmentConfirmationStatusFilterParam,
} from './AppointmentConfirmationStatusField.types';

export const FILTER_SEPARATOR = ',';
export const APPOINTMENT_CONFIRMATION_STATUS_ID_MAP: Record<AppointmentConfirmationStatus, number> = {
   CONFIRMED: 0,
   NOT_CONFIRMED: 1,
};

export const getAppointmentConfirmationQueryValue = (
   appointmentConfirmationStatus: AppointmentConfirmationStatus
): boolean => {
   return appointmentConfirmationStatus === 'CONFIRMED';
};

export const getAppointmentConfirmationStatusFilterCount = (): number => {
   return Object.keys(APPOINTMENT_CONFIRMATION_STATUS_ID_MAP).length;
};

export const getAppointmentConfirmationStatusFilterSearchParamValue = (
   appointmentConfirmationStatuses: AppointmentConfirmationStatus[]
): AppointmentConfirmationStatusFilterParam => {
   return appointmentConfirmationStatuses
      .map((status) => APPOINTMENT_CONFIRMATION_STATUS_ID_MAP[status])
      .join(FILTER_SEPARATOR);
};

export const getAppointmentConfirmationStatusFromSearchParam = (
   searchParamValue: number
): AppointmentConfirmationStatus | null => {
   const foundEntry = Object.entries(APPOINTMENT_CONFIRMATION_STATUS_ID_MAP).find(([, entrySearchParamValue]) => {
      return searchParamValue === entrySearchParamValue;
   });
   return foundEntry ? (foundEntry[0] as AppointmentConfirmationStatus) : null;
};

export const mapAppointmentConfirmationStatusFilterParamToAppointmentConfirmationStatus = (
   appointmentConfirmationStatusSearchParam: string | null
): AppointmentConfirmationStatus[] => {
   if (!appointmentConfirmationStatusSearchParam) {
      return [];
   }

   const selectedAppointmentConfirmationStatus = appointmentConfirmationStatusSearchParam
      .split(FILTER_SEPARATOR)
      .reduce((acc, str) => {
         const num = Number(str);
         if (!Number.isNaN(num)) {
            acc.add(num);
         }

         return acc;
      }, new Set());

   if (!selectedAppointmentConfirmationStatus.size) {
      return [];
   }

   return Object.entries(APPOINTMENT_CONFIRMATION_STATUS_ID_MAP).reduce<AppointmentConfirmationStatus[]>(
      (acc, [confirmationStatus, id]) => {
         if (selectedAppointmentConfirmationStatus.has(id)) {
            acc.push(confirmationStatus as AppointmentConfirmationStatus);
         }

         return acc;
      },
      []
   );
};

export const isAppointmentConfirmationFilterActive = (): boolean => {
   const searchParams = new URLSearchParams(location.search);
   return Boolean(searchParams.get(visitPaths.APPOINTMENT_CONFIRMATION_STATUS_SEARCH_PARAM));
};
